import React  from 'react';
import web from "./logo1.svg"

import './index.css'; 
import img1 from './Images/newz.jpg';
import img2 from './Images/blog.jpg';


 function Home(){
  
       
    return (
        
        
        <>
       
            
            
       
        </>
      
    );
  }
  export default Home;
  